import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import Newsletter from "../components/Newsletter";
import BlogDetailsInner from "../components/BlogDetailsInner";
import HeaderTwo from "../components/HeaderTwo";
import FooterTwo from "../components/FooterTwo";
import { AwsBlog } from "../data";
import FooterThree from "../components/FooterThree";



const BlogDetails = ({data}) => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={data?.title || "Blog Details"} />

      {/* HeaderFive */}
      <HeaderTwo />

      {/* Breadcrumb */}
      <Breadcrumb title={data?.title || "Blog Details"} bg={data?.bannerImg || "/assets/img/bg/cmbanner.png"} />

      {/* BlogDetailsInner */}
      <BlogDetailsInner blogdata={data || AwsBlog}/>

      {/* Newsletter */}
      <Newsletter />

      {/* FooterOne */}
      <FooterThree />

    </>
  );
};

export default BlogDetails;
